var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { pathOr } from 'ramda';
import { styledTheme } from '../theme';
var curryGet = function (theme) {
    var getPath = function (path) {
        var getValue = function (value) {
            var parts = path.split('.');
            var pathWithValue = __spreadArrays(parts, [value]);
            return pathOr('', pathWithValue, theme);
        };
        return getValue;
    };
    return getPath;
};
var composeGetter = function (path) {
    var withValue = function (value) {
        var withTheme = function (_a) {
            var theme = _a.theme;
            return curryGet(theme)(path)(value);
        };
        return withTheme;
    };
    return withValue;
};
var gettersFactory = function () {
    var keys = Object.keys(styledTheme);
    return keys.reduce(function (acc, key) {
        var _a;
        return __assign(__assign({}, acc), (_a = {}, _a[key] = composeGetter(key), _a));
    }, {});
};
var get = gettersFactory();
export { curryGet };
export default get;
//# sourceMappingURL=getters.js.map